const header = document.querySelector('header');
let prevY = window.scrollY; // 前回のスクロール位置を初期化

window.addEventListener('scroll', () => {
  const currentY = window.scrollY; // 現在のスクロール位置を取得
  if (currentY < prevY) { // 上にスクロールしている場合
    header.classList.remove('hidden'); // hiddenクラスを削除して表示する
  } else { // 下にスクロールしている場合
    if (currentY > 0) { // Safariなどのバウンススクロール対策
      header.classList.add('hidden'); // hiddenクラスを追加して非表示にする
    }
  }

  // .scrollクラスの追加・削除
  if (currentY > 0) {
    header.classList.add('scroll'); // スクロールしたら.scrollクラスを追加
  } else {
    header.classList.remove('scroll'); // スクロール位置が0の場合は.scrollクラスを削除
  }
  prevY = currentY;
});

$(function () {
  let isMenuToggleSet = false; // イベントが設定済みかを記録

  // 関数でイベントを設定
  function setupMenuToggle() {
    if (isMenuToggleSet) return; // すでに設定済みならスキップ
    isMenuToggleSet = true; // 設定済み状態に変更

    // 影響範囲を狭めるため、イベントに namespace を付ける
    $('#menu_btn, .overlay').on('click.menu', function () {
      $('#menu_btn').toggleClass('active');
      $('body, #gNav, .overlay').toggleClass('open');
    });

    // 同一ページ内リンクでも閉じる（#xxx / /current/#xxx / https://.../current/#xxx）
    // ※メニューが開いている時だけ閉じる（閉じている時に誤って開かないように）
    $('#gNav a').on('click.menuClose', function () {
      const href = $(this).attr('href');
      if (!href) return;

      // メニューが開いていないなら何もしない（誤トグル防止）
      if (!$('.overlay').hasClass('open')) return;

      // 1) "#xxx" 形式
      if (href.charAt(0) === '#') {
        $('.overlay').trigger('click');
        return;
      }

      // 2) "/current/#xxx" や "https://.../current/#xxx" 形式（同一ページ判定）
      const a = document.createElement('a');
      a.href = href;

      const currentPath = location.pathname.replace(/\/$/, '');
      const linkPath = (a.pathname || '').replace(/\/$/, '');

      const sameHost = (a.hostname === location.hostname);
      const samePath = (linkPath === currentPath);
      const hasHash = (a.hash && a.hash !== '#');

      if (sameHost && samePath && hasHash) {
        $('.overlay').trigger('click');
      }
    });
  }

  // 関数でイベントを削除
  function removeMenuToggle() {
    if (!isMenuToggleSet) return; // 設定されていないならスキップ
    isMenuToggleSet = false; // 未設定状態に変更

    // namespace 指定でこのスクリプト分だけ外す
    $('#menu_btn, .overlay').off('click.menu');
    $('#gNav a').off('click.menuClose');
  }

  // ウィンドウサイズに応じて適用
  function handleMenuForScreenSize() {
    if (window.innerWidth <= 767) {
      setupMenuToggle();
    } else {
      removeMenuToggle();
      // PC版でメニューを閉じた状態にリセット
      $('#menu_btn').removeClass('active');
      $('body, #gNav, .overlay').removeClass('open');
    }
  }

  // 初回判定
  handleMenuForScreenSize();

  // リサイズ時の判定
  $(window).on('resize', function () {
    handleMenuForScreenSize();
  });
});

$(function () {
  $('a[href^="#"]').on("click", function () {
    var speed = 600;
    var header_height = ($('header').outerHeight() || 0) - 1; // ヘッダーの高さから1px引く
    var href = $(this).attr("href");
    var target = $(href === "#" || href === "" ? "html" : href);
    var position = target.offset().top - header_height;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

jQuery(function() {
  // .parent内の.fadeInUp要素を順番にアニメーション
  $('.parent').each(function() {
    const children = $(this).find('.fadeInUp');
    children.each(function(index) {
      $(this).css('opacity', 0).one('inview', function(e, isIn) {
        if (isIn) {
          KUTE.fromTo(this, {
            opacity: 0,
            translateY: 20
          }, {
            opacity: 1,
            translateY: 0
          }, {
            duration: 1000,
            delay: index * 300, // 順番に遅延を追加
            easing: 'easingSinusoidalOut'
          }).start();
        }
      });
    });
  });

  // parentの外にある.fadeInUp要素にもアニメーション
  $('.fadeInUp').not('.parent .fadeInUp').each(function() {
    $(this).css('opacity', 0).one('inview', function(e, isIn) {
      if (isIn) {
        KUTE.fromTo(this, {
          opacity: 0,
          translateY: 20
        }, {
          opacity: 1,
          translateY: 0
        }, {
          duration: 1000,
          delay: 0, // 遅延なし
          easing: 'easingSinusoidalOut'
        }).start();
      }
    });
  });
});

jQuery(function () {
  // 対象要素を処理
  $('.js-animation').each(function () {
    const $this = $(this);
    const originalHtml = $this.html(); // 元のHTMLを取得

    // 一時的にHTMLを安全に扱うための div に変換
    const tempDiv = $('<div>').html(originalHtml);

    // 元のHTMLをクリア
    $this.html('');

    tempDiv.contents().each(function () {
      if (this.nodeType === 3) {
        // テキストノードの場合
        const text = $(this).text();
        text.split('').forEach((char, index) => {
          const delay = index * 100; // 各文字に100msずつ遅延
          $this.append(`<span style="opacity: 0; display: inline-block;" data-delay="${delay}">${char}</span>`);
        });
      } else {
        // テキストノード以外（例: <br>）の場合
        $this.append($(this).clone()); // 元のノードをコピーして追加
      }
    });
  });

  // inview を検出してアニメーションを適用
  $('.js-animation').one('inview', function () {
    $(this)
      .find('span')
      .each(function () {
        const delay = $(this).data('delay');
        KUTE.fromTo(
          this,
          { opacity: 0, translateY: 20 },
          { opacity: 1, translateY: 0 },
          { duration: 500, delay: delay, easing: 'easingSinusoidalOut' }
        ).start();
      });
  });
});

// ページトップボタン
$(function () {
  const pageTop = $("#page-top");
  pageTop.hide();

  // スクロールで表示・非表示を切り替え
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }
  });

  // ページトップに戻るアニメーション
  pageTop.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });

  // フッター手前でストップと位置調整
  $(window).on("scroll resize", function () {
    const scrollHeight = $(document).height(); // ドキュメント全体の高さ
    const scrollPosition = $(window).height() + $(window).scrollTop(); // 現在のスクロール位置
    const footHeight = $("footer").innerHeight(); // フッターの高さ
    const isSP = window.innerWidth <= 767; // SP判定（767px以下）

    if (scrollHeight - scrollPosition <= footHeight) {
      // フッター手前で止まる場合
      pageTop.css({
        position: "absolute",
        bottom: footHeight,
        marginBottom: isSP ? "-4rem" : "-4.8rem", // フッター手前でのmargin-bottom
      });
    } else {
      // 通常時の位置
      pageTop.css({
        position: "fixed",
        bottom: isSP ? "2rem" : "3rem", // SPとPCでbottomの値を分岐
        marginBottom: "0", // 通常時はmargin-bottomをリセット
      });
    }
  });

  // 初期判定
  $(window).trigger("scroll");
});

// accordion
(function($){
  var isSp = null;
  var CLOSE_DELAY = 200; // 150〜300msで調整

  function closeWrap($w) {
    clearTimeout($w.data('accordionTimer'));
    $w.removeClass('active');
    $w.find('.js-accordion').stop(true, true).fadeOut('fast');
  }

  function openWrap($w) {
    clearTimeout($w.data('accordionTimer'));
    $w.addClass('active');
    $w.find('.js-accordion').stop(true, true).fadeIn('fast');
  }

  function initAccordion() {
    var nowSp = window.matchMedia('(max-width: 768px)').matches;
    if (nowSp === isSp) return;
    isSp = nowSp;

    var $wrap  = $('.js-accordionWrap');
    var $panel = $('.js-accordion');

    $wrap.off('.accordion');

    if (isSp) {
      $panel.hide();
      $wrap.removeClass('active');

      $wrap.on('click.accordion', '> a', function(e) {
        e.preventDefault();
        var $parent = $(this).closest('.js-accordionWrap');
        $parent.toggleClass('active');
        $parent.find('.js-accordion').stop(true, true).slideToggle('fast');
      });

    } else {
      $panel.hide();
      $wrap.removeClass('active');

      $wrap.on('mouseenter.accordion', function() {
        var $this = $(this);

        // 他のメガメニューは即閉じ（重なり防止）
        $wrap.not($this).each(function(){
          closeWrap($(this));
        });

        // 自分は開く（隙間チラつき対策のため timer も解除）
        openWrap($this);
      });

      $wrap.on('mouseleave.accordion', function() {
        var $this = $(this);

        clearTimeout($this.data('accordionTimer'));
        var t = setTimeout(function(){
          closeWrap($this);
        }, CLOSE_DELAY);

        $this.data('accordionTimer', t);
      });
    }
  }

  $(function() {
    initAccordion();
  });

  var resizeTimer = null;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAccordion, 150);
  });

  // 授業概要
  document.addEventListener('DOMContentLoaded', () => {
    const HEADER_SELECTOR = '#header';

    const getHeaderOffset = () => {
      const header = document.querySelector(HEADER_SELECTOR);
      if (!header) return 0;

      // 固定ヘッダーでないならオフセット不要
      const pos = getComputedStyle(header).position;
      if (pos !== 'fixed' && pos !== 'sticky') return 0;

      return Math.ceil(header.getBoundingClientRect().height);
    };

    document.querySelectorAll('.p-hrdDetail__content').forEach((section) => {
      const links = section.querySelectorAll(
        '.p-hrdDetail__listWrap .p-hrdDetail__listItem a[data-target]'
      );

      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const selector = link.getAttribute('data-target');
          if (!selector) return;

          const target = section.querySelector(selector);
          if (!target) return;

          const details =
            target.tagName === 'DETAILS' ? target : target.closest('details.faq__item');
          if (!details) return;

          // 他を閉じる（不要なら消す）
          section.querySelectorAll('details.faq__item[open]').forEach((d) => {
            if (d !== details) d.removeAttribute('open');
          });

          details.setAttribute('open', '');

          const offset = getHeaderOffset();
          const top =
            details.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({ top, behavior: 'smooth' });

          const summary = details.querySelector('summary');
          if (summary) summary.focus({ preventScroll: true });
        });
      });
    });
  });

  // Swiper
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.js-reccurentFv');
    if (!root) return;
    const elPgPc = document.querySelector('.js-reccurentFvPaginationPc');
    const elPgSp = document.querySelector('.js-reccurentFvPaginationSp');
    const elPrev = document.querySelector('.js-reccurentFvPrev');
    const elNext = document.querySelector('.js-reccurentFvNext');
    const elStop = document.querySelector('.js-reccurentFvStop');

    const mq = window.matchMedia('(max-width: 767px)');
    let swiper = null;

    const buildOptions = (isSp) => {
      const opt = {
        loop: true,
        pagination: {
          el: isSp ? elPgSp : elPgPc,
          clickable: true,
        },
      };

      // SPだけ navigation を有効化
      if (isSp) {
        opt.navigation = { nextEl: elNext, prevEl: elPrev };
      }

      opt.autoplay = { delay: 5000, disableOnInteraction: false };
      return opt;
    };

    const init = () => {
      const isSp = mq.matches;

      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }

      swiper = new Swiper(root, buildOptions(isSp));

      // 停止ボタン
      if (elStop) {
        elStop.onclick = () => {
          if (!swiper || !swiper.autoplay) return;

          const pressed = elStop.getAttribute('aria-pressed') === 'true';
          if (pressed) {
            swiper.autoplay.start();
            elStop.setAttribute('aria-pressed', 'false');
          } else {
            swiper.autoplay.stop();
            elStop.setAttribute('aria-pressed', 'true');
          }
        };
      }
    };

    init();
    mq.addEventListener('change', init);
  });
  

  window.addEventListener('load', () => {
  const target = document.querySelectorAll('.heading-jp.js-animation span');

  target.forEach((span) => {
    // 半角スペースが「空のspan」になっているケース
    if (span.textContent === '') {
      span.textContent = '\u00A0'; // 改行されないスペース（&nbsp;相当）
      span.classList.add('is-space');
    }

    // 半角スペースが残っているが見えない/詰まるケース
    if (span.textContent === ' ') {
      span.textContent = '\u00A0';
      span.classList.add('is-space');
    }
  });
});

})(jQuery);
